import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale.ts'

/**
 *
 * @param locale fr-fr, en-us, es-us
 * @returns the language code from the locale
 *
 * "fr-fr" -> "fr"
 *
 * "es-us" -> "es"
 *
 * "ja-jp" -> "ja"
 */
export function getLanguageFromLocale(locale: Bcp47Locale): string {
  return locale?.split('-')?.[0]
}
